/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TestCaseStatus = {
    New: 'new',
    Pending: 'pending',
    Initialized: 'initialized',
    Error: 'error'
} as const;
export type TestCaseStatus = typeof TestCaseStatus[keyof typeof TestCaseStatus];


export function instanceOfTestCaseStatus(value: any): boolean {
    for (const key in TestCaseStatus) {
        if (Object.prototype.hasOwnProperty.call(TestCaseStatus, key)) {
            if (TestCaseStatus[key as keyof typeof TestCaseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TestCaseStatusFromJSON(json: any): TestCaseStatus {
    return TestCaseStatusFromJSONTyped(json, false);
}

export function TestCaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCaseStatus {
    return json as TestCaseStatus;
}

export function TestCaseStatusToJSON(value?: TestCaseStatus | null): any {
    return value as any;
}

export function TestCaseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): TestCaseStatus {
    return value as TestCaseStatus;
}

